import React from 'react';

import { Box, CircularProgress } from '@mui/material';

type Props = {
  minHeight?: number;
};
export default function LoadingIndicator({ minHeight = 96 }: Props): JsxNode {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight }}>
      <CircularProgress size={32} />
    </Box>
  );
}
